import { statAssets } from '../../constants/assets'

type ClockGlyphProps = {
  size: number
}

/** The clock is drawn as two stacked exports: the dial and the hands. */
export const ClockGlyph = ({ size }: ClockGlyphProps) => (
  <span className="relative block overflow-hidden" style={{ width: size, height: size }}>
    <span className="absolute bottom-[18.75%] left-1/2 top-[6.25%] block w-[20px] -translate-x-1/2 overflow-hidden">
      <img alt="" aria-hidden className="absolute inset-0 block size-full max-w-none" src={statAssets.clockFace} />
      <span className="absolute bottom-[12.5%] left-[8.33%] right-[8.34%] top-[12.5%] block">
        <img alt="" aria-hidden className="block size-full max-w-none" src={statAssets.clockHands} />
      </span>
    </span>
  </span>
)
